import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils"

import {withTranslation} from "react-i18next";
import Autocomplete from "../../../../../../components/autocomplete/Autocomplete";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Select from "../../../../../../components/select/Select";
import MalattieService from "../../../../../../services/MalattieService";
const zoneItalia = OggettiUtili.ZoneItalia
class SezioneQuattro extends Component {

    state = {
        sezioneQuattro: {
            farmaci: "",
            listaFarmaci: [
                {farmaciTipo: "", giorniFarmaciTipo: ""},
                {farmaciTipo: "", giorniFarmaciTipo: ""},
                {farmaciTipo: "", giorniFarmaciTipo: ""},
                {farmaciTipo: "", giorniFarmaciTipo: ""}
            ],
            fruttiDiMare: "",
            fruttiDiMareCrudi: "",
            fruttiBosco: "",
            fruttiBoscoTipo: "",
            acqua: "",
            notte: "",
            luogoNotte: "",
            zonaItalia: "",
            periodoNotte: "",
            corretto: []
        },
        controlloAutocomplete:{
            farmaciTipo0:true,
            farmaciTipo1:true,
            farmaciTipo2:true,
            farmaciTipo3:true,
        },
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        luogoNotteAutocomplete:true,
        listaFarmaci:[],
        listaFarmaciPerCodice:[]
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this)
        this.validate = this.validate.bind(this)

    }

    componentDidMount() {
        MalattieService.getListaFarmaci().then(res=>{
            if (res.status===200){
                let sezioneQuattro = this.state.sezioneQuattro
                let controlloInput=this.state.luogoNotteAutocomplete
                let controlloAutocomplete=this.state.controlloAutocomplete
                let arrayToMap=Utils.arrayToMap(res.data,"codice")
                if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneQuattro) {
                    let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneQuattro))
                    sezioneQuattro.farmaci = propsSezione.farmaci ? propsSezione.farmaci : ""
                    if (propsSezione.listaFarmaci) {
                        for (let i = 0; i < propsSezione.listaFarmaci.length; i++) {
                            sezioneQuattro.listaFarmaci[i].farmaciTipo = propsSezione.listaFarmaci[i].farmaciTipo && arrayToMap[propsSezione.listaFarmaci[i].farmaciTipo] ? arrayToMap[propsSezione.listaFarmaci[i].farmaciTipo].descrizione : propsSezione.listaFarmaci[i].farmaciTipo
                            sezioneQuattro.listaFarmaci[i].giorniFarmaciTipo = propsSezione.listaFarmaci[i].giorniFarmaciTipo ? propsSezione.listaFarmaci[i].giorniFarmaciTipo : ""
                        }
                        controlloAutocomplete.farmaciTipo0=sezioneQuattro.listaFarmaci[0].farmaciTipo && arrayToMap[sezioneQuattro.listaFarmaci[0].farmaciTipo]
                        controlloAutocomplete.farmaciTipo1=sezioneQuattro.listaFarmaci[1].farmaciTipo && arrayToMap[sezioneQuattro.listaFarmaci[1].farmaciTipo]
                        controlloAutocomplete.farmaciTipo2=sezioneQuattro.listaFarmaci[2].farmaciTipo && arrayToMap[sezioneQuattro.listaFarmaci[2].farmaciTipo]
                        controlloAutocomplete.farmaciTipo3=sezioneQuattro.listaFarmaci[3].farmaciTipo && arrayToMap[sezioneQuattro.listaFarmaci[3].farmaciTipo]


                    }
                    sezioneQuattro.fruttiDiMare = propsSezione.fruttiDiMare ? propsSezione.fruttiDiMare : ""
                    sezioneQuattro.fruttiDiMareCrudi = propsSezione.fruttiDiMareCrudi ? propsSezione.fruttiDiMareCrudi : ""
                    sezioneQuattro.fruttiBosco = propsSezione.fruttiBosco ? propsSezione.fruttiBosco : ""
                    sezioneQuattro.fruttiBoscoTipo = propsSezione.fruttiBoscoTipo ? propsSezione.fruttiBoscoTipo : ""
                    sezioneQuattro.acqua = propsSezione.acqua ? propsSezione.acqua : ""
                    sezioneQuattro.notte = propsSezione.notte ? propsSezione.notte : ""
                    sezioneQuattro.luogoNotte=propsSezione.luogoNotte && this.state.nazioniPerCodice[propsSezione.luogoNotte] ? this.state.nazioniPerCodice[propsSezione.luogoNotte] : propsSezione.luogoNotte ? propsSezione.luogoNotte : ""
                    controlloInput=sezioneQuattro.luogoNotte && sezioneQuattro.luogoNotte.codice
                    sezioneQuattro.zonaItalia = propsSezione.zonaItalia ? propsSezione.zonaItalia : ""
                    sezioneQuattro.periodoNotte = propsSezione.periodoNotte ? propsSezione.periodoNotte : ""
                }
                this.setState({listaFarmaci:res.data,listaFarmaciPerCodice:arrayToMap,sezioneQuattro: sezioneQuattro, luogoNotteAutocomplete : controlloInput})
                this.controllaDati();
                this.props.setSezioneQuattro(this.state.sezioneQuattro)
            }
        }).catch(reason => {
            console.log("ERRORE OPERATION GET LISTA FARMACI: "+reason)
        })


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneQuattro(this.state.sezioneQuattro, this.validate(), res)
        }

    }

    validate() {

        if (this.state.sezioneQuattro.periodoNotte) {
            let validateperiodoNotte = Utils.checkDateInterval(this.state.sezioneQuattro.periodoNotte, "31/12/1899");
            let validateperiodoNotteOdierna = Utils.checkDateInterval(this.state.sezioneQuattro.periodoNotte, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validateperiodoNotte) {
                return "Messages.DataPeriodoNotte"
            } else if (!validateperiodoNotteOdierna) {
                return "Messages.DataPeriodoNotteOdierna"
            }
        }

        if (this.state.sezioneQuattro.farmaci !== "01" &&
            (this.state.sezioneQuattro.listaFarmaci[0].farmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[1].farmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[2].farmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[3].farmaciTipo)) return "Messages.ERR_01_02_0D_0P"
        else if (this.state.sezioneQuattro.farmaci !== "01" &&
            (this.state.sezioneQuattro.listaFarmaci[0].giorniFarmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[1].giorniFarmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[2].giorniFarmaciTipo ||
                this.state.sezioneQuattro.listaFarmaci[3].giorniFarmaciTipo)) return "Messages.ERR_01_02_0D_0Q"

        if (this.state.sezioneQuattro.fruttiDiMare !== "01" && this.state.sezioneQuattro.fruttiDiMareCrudi) return "Messages.ERR_01_02_0D_0R"
        else if (this.state.sezioneQuattro.fruttiBosco !== "01" && this.state.sezioneQuattro.fruttiBoscoTipo) return "Messages.ERR_01_02_0D_0S"
        else if (this.state.sezioneQuattro.notte !== "01" && this.state.sezioneQuattro.luogoNotte) return "Messages.ERR_01_02_0D_0T"
        else if (this.state.sezioneQuattro.notte !== "01" && this.state.sezioneQuattro.periodoNotte) return "Messages.ERR_01_02_0D_0U"

        return ""

    }


    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneQuattro))
        let ObjectForBackEnd = {}
        ObjectForBackEnd["farmaci"] = dati.farmaci
        ObjectForBackEnd["fruttiDiMare"] = dati.fruttiDiMare
        ObjectForBackEnd["fruttiDiMareCrudi"] = dati.fruttiDiMareCrudi
        ObjectForBackEnd["fruttiBosco"] = dati.fruttiBosco
        ObjectForBackEnd["fruttiBoscoTipo"] = dati.fruttiBoscoTipo
        ObjectForBackEnd["acqua"] = dati.acqua
        ObjectForBackEnd["notte"] = dati.notte
        ObjectForBackEnd["luogoNotte"] =dati.luogoNotte && dati.luogoNotte.codice ? dati.luogoNotte.codice : ""
        ObjectForBackEnd["zonaItalia"] =dati.zonaItalia
        ObjectForBackEnd["periodoNotte"] = dati.periodoNotte
        let listaFarmaci= []

        dati.listaFarmaci.forEach(farmaco =>{
            if (farmaco && (farmaco.giorniFarmaciTipo || farmaco.farmaciTipo)) {
                let object = {
                    giorniFarmaciTipo: farmaco.giorniFarmaciTipo,
                    farmaciTipo: farmaco.farmaciTipo && farmaco.farmaciTipo.codice ? farmaco.farmaciTipo.codice : farmaco.farmaciTipo
                }
                listaFarmaci.push(object)
            }
        })
        ObjectForBackEnd["listaFarmaci"]=listaFarmaci


        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res
    }

    controllaDati() {

        let dati = this.state.sezioneQuattro
        dati.corretto = []

        if(dati.farmaci === "01" && !dati.listaFarmaci[0].farmaciTipo) dati.corretto[0] = "Campo \"Se si, quali?\" mancante";
        if(dati.farmaci === "01" && !dati.listaFarmaci[0].giorniFarmaciTipo) dati.corretto[1] = "Campo \"Per quanto tempo (giorni)?\" mancante";
        if(dati.fruttiDiMare === "01" && !dati.fruttiDiMareCrudi) dati.corretto[2] = "Campo \"Se sì, i frutti di mare consumati erano tutti o in parte crudi?\" mancante";
        if(dati.fruttiBosco === "01" && !dati.fruttiBoscoTipo) dati.corretto[3] = "Se sì, i frutti di bosco erano\" mancante";
        if(dati.notte === "01" && !dati.luogoNotte) dati.corretto[4] = "Campo \"Se si, dove?\" mancante";
        if(dati.notte === "01" && (!dati.periodoNotte || (dati.periodoNotte && Utils.isDateInValid(Utils.transformDateForBackend(dati.periodoNotte), "-")))) dati.corretto[5] = "Campo \"Se si, quando?\" mancante o errato";
        if(dati.luogoNotte?.codice === "100" && !dati.zonaItalia) dati.corretto[6] = "Campo \"Se si, dove?\" valorizzato con Italia ma il campo \"Zona dell'Italia visitata\" mancante"
    }

    riceviValoreRadioButton(event, field) {
        let sezioneQuattro = this.state.sezioneQuattro
        sezioneQuattro[field] = event
        if (sezioneQuattro.fruttiDiMare !== "01") {
            sezioneQuattro.fruttiDiMareCrudi = ""
        }
        if (sezioneQuattro.fruttiBosco !== "01") {
            sezioneQuattro.fruttiBoscoTipo = ""
        }


        this.setState({sezioneQuattro: sezioneQuattro})
    }

    riceviValoreInput(field, event) {


        let sezioneQuattro = this.state.sezioneQuattro
        let luogoNotteAutocomplete=this.state.luogoNotteAutocomplete
        let controlloAutocomplete=this.state.controlloAutocomplete
        if (field.currentTarget) {
            sezioneQuattro[field.currentTarget.id] = field.currentTarget.value
        } else {
            if (field.includes("farmaciTipo")) {
                let indice = parseInt(field.replace("farmaciTipo", ""))
                if (!event.target.value) {
                    if(indice===0) controlloAutocomplete.farmaciTipo0 = true
                    else if (indice===1) controlloAutocomplete.farmaciTipo1=true
                    else if (indice===2) controlloAutocomplete.farmaciTipo2=true
                    else if (indice===3) controlloAutocomplete.farmaciTipo3=true


                }

                sezioneQuattro.listaFarmaci[indice].farmaciTipo = event.target.value

            } else if (field.includes("giorniFarmaciTipo")) {
                let indice = parseInt(field.replace("giorniFarmaciTipo", ""))

                sezioneQuattro.listaFarmaci[indice].giorniFarmaciTipo = event.target.value

            } else{
                if (field.includes("luogoNotte") && !event.target.value) {
                    luogoNotteAutocomplete = true
                }
                sezioneQuattro[field] = event.target.value
            }
        }
        if(sezioneQuattro.luogoNotte?.codice !== "100"){
            sezioneQuattro.zonaItalia = "";
        }

        this.setState({sezioneQuattro: sezioneQuattro, luogoNotteAutocomplete: luogoNotteAutocomplete})
    }

    render() {

        const {t} = this.props;
        const zone = this.state.sezioneQuattro?.luogoNotte?.codice && this.state.sezioneQuattro.luogoNotte.codice === "100" ?
            (<div className={"row"} style={{marginTop: "10px"}}>
                <div className={"col-lg-6"}>
                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b> {t("SchedaEpatite.sezione4.zoneItalia")} </b>
                        <span className={styles.mandatoryColor}>*</span>
                    </p>
                </div>
                <div className={"col-lg-3"} style={{paddingLeft: "0px", paddingRight: "0px"}} >
                    <Select id={"zonaItalia"}
                            value={this.state.sezioneQuattro.zonaItalia}
                            onChange={this.riceviValoreInput}
                            functionMap={zoneItalia.map((oggetto) => {
                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                            })}
                    >
                    </Select>
                </div>
            </div>)
            : (<></>)
        const sezioneQuattro = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 4 - Durante le 6 settimane prima dell'inizio della malattia</h6>
                    <hr className={styles.hr}></hr>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.sezione4.domandaCinque")}</b></p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"farmaciSi"}
                                             name={"farmaci"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "farmaci")}
                                             checked={this.state.sezioneQuattro.farmaci === "01"}>
                                </RadioButton>
                                <RadioButton id={"farmaciNo"}
    name={"farmaci"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "farmaci")}
    checked={this.state.sezioneQuattro.farmaci === "02"}
    />
                                <RadioButton id={"farmaciNonSo"}
    name={"farmaci"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "farmaci")}
    checked={this.state.sezioneQuattro.farmaci === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.quali")}</b>
                                {this.state.sezioneQuattro.farmaci === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            {this.state.controlloAutocomplete.farmaciTipo0 ?
                                <Autocomplete id={"farmaciTipo0"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"farmaciTipo0"}
                                              placeholder={"Farmaco"}
                                              suggestions={this.state.listaFarmaci}
                                              value={this.state.sezioneQuattro.listaFarmaci[0].farmaciTipo}
                                /> :
                                <Input
                                    id={"farmaciTipo0"}
                                    onChange={this.riceviValoreInput}
                                    field={"farmaciTipo0"}
                                    // errorMessage={"sezione non valido"}
                                    value={this.state.sezioneQuattro.listaFarmaci[0].farmaciTipo}
                                    placeholder={"Farmaco"}
                                >
                                </Input>
                            }
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.quantiGiorni")}</b>
                                {this.state.sezioneQuattro.farmaci === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            <Input
                                id={"giorniFarmaciTipo0"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValoreInput}
                                field={"giorniFarmaciTipo0"}
                                value={this.state.sezioneQuattro.listaFarmaci[0].giorniFarmaciTipo}
                                placeholder={"Giorni"}
                            >
                            </Input>
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6"><p className={styles.labelHeader}><b>{t("SchedaEpatite.quali")}</b>
                        </p></div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            {this.state.controlloAutocomplete.farmaciTipo1 ?
                                <Autocomplete id={"farmaciTipo1"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"farmaciTipo1"}
                                              placeholder={"Farmaco"}
                                              suggestions={this.state.listaFarmaci}
                                              value={this.state.sezioneQuattro.listaFarmaci[1].farmaciTipo}
                                /> :
                                <Input
                                    id={"farmaciTipo1"}
                                    onChange={this.riceviValoreInput}
                                    field={"farmaciTipo1"}
                                    value={this.state.sezioneQuattro.listaFarmaci[1].farmaciTipo}
                                    placeholder={"Farmaco"}
                                >
                                </Input>
                            }
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.quantiGiorni")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            <Input
                                id={"giorniFarmaciTipo1"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValoreInput}
                                field={"giorniFarmaciTipo1"}
                                value={this.state.sezioneQuattro.listaFarmaci[1].giorniFarmaciTipo}
                                placeholder={"Giorni"}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6"><p className={styles.labelHeader}><b>{t("SchedaEpatite.quali")}</b>
                        </p></div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            {this.state.controlloAutocomplete.farmaciTipo2 ?
                                <Autocomplete id={"farmaciTipo2"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"farmaciTipo2"}
                                              placeholder={"Farmaco"}
                                              suggestions={this.state.listaFarmaci}
                                              value={this.state.sezioneQuattro.listaFarmaci[2].farmaciTipo}
                                /> :
                                <Input
                                    id={"farmaciTipo2"}
                                    onChange={this.riceviValoreInput}
                                    field={"farmaciTipo2"}
                                    value={this.state.sezioneQuattro.listaFarmaci[2].farmaciTipo}
                                    placeholder={"Farmaco"}
                                >
                                </Input>
                            }
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.quantiGiorni")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            <Input
                                id={"giorniFarmaciTipo2"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValoreInput}
                                field={"giorniFarmaciTipo2"}
                                value={this.state.sezioneQuattro.listaFarmaci[2].giorniFarmaciTipo}
                                placeholder={"Giorni"}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6"><p className={styles.labelHeader}><b>{t("SchedaEpatite.quali")}</b>
                        </p></div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            {this.state.controlloAutocomplete.farmaciTipo3 ?
                                <Autocomplete id={"farmaciTipo3"}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValoreInput}
                                              field={"farmaciTipo3"}
                                              placeholder={"Farmaco"}
                                              suggestions={this.state.listaFarmaci}
                                              value={this.state.sezioneQuattro.listaFarmaci[3].farmaciTipo}
                                /> :
                                <Input
                                    id={"farmaciTipo3"}
                                    onChange={this.riceviValoreInput}
                                    field={"farmaciTipo3"}
                                    value={this.state.sezioneQuattro.listaFarmaci[3].farmaciTipo}
                                    placeholder={"Farmaco"}
                                >
                                </Input>
                            }
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.quantiGiorni")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px"}}>
                            <Input
                                id={"giorniFarmaciTipo3"}
                                type={"number"}
                                min="0"
                                onChange={this.riceviValoreInput}
                                field={"giorniFarmaciTipo3"}
                                value={this.state.sezioneQuattro.listaFarmaci[3].giorniFarmaciTipo}
                                placeholder={"Giorni"}
                            >
                            </Input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaSei")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"fruttiDiMareSi"}
                                             name={"fruttiDiMare"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "fruttiDiMare")}
                                             checked={this.state.sezioneQuattro.fruttiDiMare === "01"}>
                                </RadioButton>
                                <RadioButton id={"fruttiDiMareNo"}
    name={"fruttiDiMare"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "fruttiDiMare")}
    checked={this.state.sezioneQuattro.fruttiDiMare === "02"}
    />
                                <RadioButton id={"fruttiDiMareNonSo"}
    name={"fruttiDiMare"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "fruttiDiMare")}
    checked={this.state.sezioneQuattro.fruttiDiMare === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaSette")}</b>
                                {this.state.sezioneQuattro.fruttiDiMare === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"fruttiDiMareCrudiSi"}
                                             name={"fruttiDiMareCrudi"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             disabled={this.state.sezioneQuattro.fruttiDiMare !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "fruttiDiMareCrudi")}
                                             checked={this.state.sezioneQuattro.fruttiDiMareCrudi === "01"}>
                                </RadioButton>
                                <RadioButton id={"fruttiDiMareCrudiNo"}
    name={"fruttiDiMareCrudi"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    disabled={this.state.sezioneQuattro.fruttiDiMare !== "01"}
    onClick={() => this.riceviValoreRadioButton("02", "fruttiDiMareCrudi")}
    checked={this.state.sezioneQuattro.fruttiDiMareCrudi === "02"}
    />
                                <RadioButton id={"fruttiDiMareCrudiNonSo"}
    name={"fruttiDiMareCrudi"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    disabled={this.state.sezioneQuattro.fruttiDiMare !== "01"}
    onClick={() => this.riceviValoreRadioButton("03", "fruttiDiMareCrudi")}
    checked={this.state.sezioneQuattro.fruttiDiMareCrudi === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaOtto")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"fruttiBoscoSi"}
                                             name={"fruttiBosco"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "fruttiBosco")}
                                             checked={this.state.sezioneQuattro.fruttiBosco === "01"}>
                                </RadioButton>
                                <RadioButton id={"fruttiBoscoNo"}
    name={"fruttiBosco"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "fruttiBosco")}
    checked={this.state.sezioneQuattro.fruttiBosco === "02"}
    />
                                <RadioButton id={"fruttiBoscNonSo"}
    name={"fruttiBosco"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "fruttiBosco")}
    checked={this.state.sezioneQuattro.fruttiBosco === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaNove")}</b>
                                {this.state.sezioneQuattro.fruttiBosco === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"fruttiBoscoTipo1"}
                                             name={"fruttiBoscoTipo"} label={"Congelati"}
                                             value={"01"}
                                             disabled={this.state.sezioneQuattro.fruttiBosco !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "fruttiBoscoTipo")}
                                             checked={this.state.sezioneQuattro.fruttiBoscoTipo === "01"}>
                                </RadioButton>
                                <RadioButton id={"fruttiBoscoTipo2"}
    name={"fruttiBoscoTipo"} label={"Freschi"}
    value={"02"}
    disabled={this.state.sezioneQuattro.fruttiBosco !== "01"}
    onClick={() => this.riceviValoreRadioButton("02", "fruttiBoscoTipo")}
    checked={this.state.sezioneQuattro.fruttiBoscoTipo === "02"}
    />
                                <RadioButton id={"fruttiBoscoTipo3"}
    name={"fruttiBoscoTipo"} label={"Entrambi"}
    value={"03"}
    disabled={this.state.sezioneQuattro.fruttiBosco !== "01"}
    onClick={() => this.riceviValoreRadioButton("03", "fruttiBoscoTipo")}
    checked={this.state.sezioneQuattro.fruttiBoscoTipo === "03"}
    />
                                <RadioButton id={"fruttiBoscoTipo4"}
    name={"fruttiBoscoTipo"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"04"}
    disabled={this.state.sezioneQuattro.fruttiBosco !== "01"}
    onClick={() => this.riceviValoreRadioButton("04", "fruttiBoscoTipo")}
    checked={this.state.sezioneQuattro.fruttiBoscoTipo === "04"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaDieci")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"acquaSi"}
                                             name={"acqua"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "acqua")}
                                             checked={this.state.sezioneQuattro.acqua === "01"}>
                                </RadioButton>
                                <RadioButton id={"acquaNo"}
    name={"acqua"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "acqua")}
    checked={this.state.sezioneQuattro.acqua === "02"}
    />
                                <RadioButton id={"acquaNonSo"}
    name={"acqua"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "acqua")}
    checked={this.state.sezioneQuattro.acqua === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione4.domandaUndici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"notteSi"}
                                             name={"notte"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "notte")}
                                             checked={this.state.sezioneQuattro.notte === "01"}>
                                </RadioButton>
                                <RadioButton id={"notteNo"}
    name={"notte"} label={t("SchedaEpatite.risposteTipoUno.no")}
    onClick={() => this.riceviValoreRadioButton("02", "notte")}
    checked={this.state.sezioneQuattro.notte === "02"}
    />
                                <RadioButton id={"notteNonSo"}
    name={"notte"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "notte")}
    checked={this.state.sezioneQuattro.notte === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.dove")}</b>
                                {this.state.sezioneQuattro.notte === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            {(this.state.sezioneQuattro.luogoNotte && this.state.sezioneQuattro.luogoNotte.codice) || !this.state.sezioneQuattro.luogoNotte || this.state.luogoNotteAutocomplete ?
                            <Autocomplete id={"luogoNotte"}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValoreInput}
                                          field={"luogoNotte"}
                                          placeholder={t("SchedaEpatite.dove")}
                                          suggestions={this.state.nazioni}
                                          value={this.state.sezioneQuattro.luogoNotte}
                            />:
                            <Input
                                id="luogoNotte"
                                onChange={this.riceviValoreInput}
                                field={"luogoNotte"}
                                value={this.state.sezioneQuattro.luogoNotte}
                                placeholder={"Luogo"}
                            >
                            </Input>
                            }
                        </div>

                    </div>
                    {zone}
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.quando")}</b>
                                {this.state.sezioneQuattro.notte === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id={"periodoNotte"}
                                field={"periodoNotte"}
                                value={this.state.sezioneQuattro.periodoNotte}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneQuattro.periodoNotte === "" ||
                                    this.state.sezioneQuattro.periodoNotte == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneQuattro.periodoNotte), "-")}>
                            </Calendar>

                        </div>

                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneQuattro}
        </div>
    }


}

export default withTranslation('common')(SezioneQuattro)
